/**
 * Yup wrapper:
 * - every string() schema auto-trims leading/trailing whitespace
 * - every number() schema rejects values outside JS safe-integer range
 *   (same ceiling Joi uses: Number.MAX_SAFE_INTEGER)
 *
 * Import from "utils/yup" instead of "yup".
 */
import * as YupModule from "yup"
import { getSafeNumberLimitMessage } from "components/Common/validationMessages"
import {
  isSafeNumericValue,
  NUMERIC_SAFE_MAX,
} from "utils/numericValidation"

export const string = (...args) => YupModule.string(...args).trim()

export const number = (...args) =>
  YupModule.number(...args)
    .max(NUMERIC_SAFE_MAX, getSafeNumberLimitMessage)
    .test(
      "safe-number",
      getSafeNumberLimitMessage,
      value => isSafeNumericValue(value)
    )

export {
  mixed,
  boolean,
  bool,
  date,
  array,
  object,
  ref,
  lazy,
  reach,
  getIn,
  addMethod,
  setLocale,
  ValidationError,
  isSchema,
  printValue,
  tuple,
  defaultLocale,
  ArraySchema,
  BooleanSchema,
  DateSchema,
  MixedSchema,
  NumberSchema,
  ObjectSchema,
  Schema,
  StringSchema,
  TupleSchema,
} from "yup"

const Yup = {
  ...YupModule,
  string: (...args) => YupModule.string(...args).trim(),
  number: (...args) => number(...args),
}

export default Yup
